import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import AppConfigService from 'app/core/app-config.service';

@Injectable({ providedIn: 'root' })
export default class CouponRxService {
  public resourceUrl = `${AppConfigService.envConfig.fssServicesBaseUrl}api/coupons`;

  constructor(protected http: HttpClient) {}

  getNonBJCData(patientId) {
    return this.http.get(`${AppConfigService.envConfig.fssServicesBaseUrl}api/rx/rxProfile/${patientId}`);
  }

  uploadImage(payload: FormData, patientId, imageType) {
    return this.http.post(`${AppConfigService.envConfig.fssServicesBaseUrl}api/coupons/uploadFile/${patientId}/imageType/${imageType}`, payload);
  }

  getImage(imageURL: string): Observable<Blob> {
    return this.http.get(`${AppConfigService.envConfig.fssServicesBaseUrl}${imageURL}`, { responseType: 'blob' });
  }

  deleteImage(patientId, fileName) {
    return this.http.delete(`${AppConfigService.envConfig.fssServicesBaseUrl}api/coupons/${patientId}/${fileName}`);
  }

  submitCoupon(payload, patientId) {
    return this.http.post(`${AppConfigService.envConfig.fssServicesBaseUrl}api/coupons/${patientId}`, payload);
  }
}
